import { render, staticRenderFns } from "./SignDialog.vue?vue&type=template&id=1723d891&scoped=true"
import script from "./SignDialog.vue?vue&type=script&lang=js"
export * from "./SignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1723d891",
  null
  
)

export default component.exports